import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  disable(event) {
    this.linkTargets.forEach((link) => {
      link.classList.add('disabled');
      link.setAttribute('disabled', 'disabled');

      link.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          return false;
        },
        { once: true },
      );
    });
  }
}
